//@ts-nocheck

'use client'

import React, { useState, useRef, useCallback } from 'react'

import { useInstantSearch, useSearchBox } from 'react-instantsearch'

import Button from '../../../atoms/Button/Button.component'
import Icon from '../../../atoms/Icon/Icon.component'

// import { debounce } from '@caffeina-siad/utils'

import * as S from './styles'

const AlgoliaSearchBox = (props) => {
  const { query, refine } = useSearchBox(props)
  const { status } = useInstantSearch()
  const [inputValue, setInputValue] = useState(query)
  const inputRef = useRef(null)

  const isSearchStalled = status === 'stalled'

  const debounce = (fn, delay = 350, timeout = 3500) => (args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(args), delay);
  }

  const debouncedRefine = useCallback(debounce(refine, 300), [])

  const handleSubmit = useCallback((event) => {
    event.preventDefault()
    event.stopPropagation()

    debouncedRefine(inputValue)

    if (inputRef.current) {
      inputRef?.current?.blur()
    }
  }, [inputValue, debouncedRefine, inputRef])

  const handleReset = useCallback((event) => {
    event.preventDefault()
    event.stopPropagation()

    setInputValue('')
    debouncedRefine('')

    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [debouncedRefine, inputRef])

  const handleChange = useCallback((event) => {
    setInputValue(event.currentTarget.value)
  }, [])

  return (
    <S.AlgoliaSearchBox>
      <form
        action=""
        role="search"
        noValidate
        onSubmit={handleSubmit}
        onReset={handleReset}
      >
        <S.AlgoliaSearchBoxIcon>
          <Icon name="magnifying-glass" size="big" />
        </S.AlgoliaSearchBoxIcon>
        <input
          ref={inputRef}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          autoFocus
          placeholder={!isSearchStalled ? 'Cerca' : 'Ricerca...'}
          spellCheck={false}
          maxLength={512}
          type="search"
          value={inputValue}
          onChange={handleChange}
        />
        <S.AlgoliaSearchBoxReset>
          <Button type="reset" ariaLabel="Reset" iconEnd="x-mark" variant="secondary" hidden={inputValue.length === 0 || isSearchStalled} />
        </S.AlgoliaSearchBoxReset>
      </form>
    </S.AlgoliaSearchBox>
  )
}

export default AlgoliaSearchBox
